import React from 'react'
import DatePicker, { ReactDatePickerProps } from 'react-datepicker'
import moment from 'moment'
import { css } from '@emotion/react'
import { colors } from 'plume-ui'

type Props = {
  placeholder: string
  error: boolean
  className?: string
} & ReactDatePickerProps

export default class DatePickerWrapper extends React.Component<Props> {
  constructor(props: Props) {
    super(props)

    moment.locale('ja', {
      months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
      weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
      week: {
        dow: 1,
      },
    })
  }

  render() {
    const errorCls = this.props.error ? 'error' : ''
    const selectedCls = this.props.selected ? 'selected' : ''
    const tenYearsFromNow = new Date(
      new Date().setFullYear(new Date().getFullYear() + 10)
    )
    const thirtyYearsAgo = new Date(
      new Date().setFullYear(new Date().getFullYear() - 30)
    )
    return (
      <DatePicker
        customInput={<InputButton />}
        dateFormat="yyyy-MM-dd"
        placeholderText={this.props.placeholder}
        className={`${errorCls} ${selectedCls}`}
        showMonthDropdown
        showYearDropdown
        maxDate={tenYearsFromNow}
        minDate={thirtyYearsAgo}
        dropdownMode="select"
        {...this.props}
      />
    )
  }
}

class InputButton extends React.Component<any> {
  render() {
    return (
      <button
        className={`input-button ${this.props.className}`}
        onClick={this.props.onClick}
        css={css`
          display: flex;
          align-items: center;
          justify-content: space-between;
          background-color: ${colors.white00};
          border: 1px solid ${colors.gray90};
          border-radius: 2px;
          color: ${this.props.value ? colors.black10 : colors.gray60};
          padding: 2px 5px;
          width: 100px;
          transition: 0.3s;
          margin-top: 2px;
          text-align: left;
          cursor: pointer;
          &:hover {
            background-color: ${colors.gray40};
          }
          &:focus {
            border-color: ${colors.gray90};
            box-shadow: none;
            -webkit-box-shadow: none;
          }
        `}
      >
        {this.props.value ? this.props.value : this.props.placeholder}
        <i className="icomoon icon-calendar"></i>
      </button>
    )
  }
}
